var lpItemScript = document.currentScript;

$(function () {
  var localeRoot = (lpItemScript && lpItemScript.dataset.localeRoot || "/").replace(/\/$/, "");
  var modelSelectPrompt = lpItemScript && lpItemScript.dataset.selectPrompt || "Please select";

  /************* タイトル用 正規化＆マージ関数 *************/
  // 表示用に \...\ / \\...\\ を "..." に戻す
  function normalizeTitleForDisplay(str) {
    return (str ?? '')
      // \TEXT\ / \\TEXT\\ / \\\TEXT\\\ → "TEXT"
      .replace(/\\+([^\\]+)\\+/g, '"$1"')
      // 念のため "" が連続してたら 1つに
      .replace(/""+/g, '"');
  }

  function stripPrefix(str, prefix) {
    str = (str ?? '').trim();
    return str.startsWith(prefix) ? str.slice(prefix.length).trim() : str;
  }

  // colText と productText を「境界の重複を消しつつ」連結
  function mergeRemoveOverlap(a, b, separator) {
    a = (a ?? '').trim();
    b = (b ?? '').trim();
    if (!a) return b;
    if (!b) return a;

    if (b.startsWith(a)) return b;
    if (a.startsWith(b)) return a;

    const max = Math.min(a.length, b.length);
    for (let k = max; k >= 1; k--) {
      if (a.slice(-k) === b.slice(0, k)) {
        return a + b.slice(k);
      }
    }
    return a + (separator || ' ');
  }

  /************* タブ初期化 *************/
  var $tabs = $(".lp-item__nav-list .js-tab"); // li.js-tab（a ではなく li 自体に .js-tab）
  if (!$tabs.length) return;

  var $initial = $tabs.filter(".is-current");
  if (!$initial.length) $initial = $tabs.first().addClass("is-current");

  function showContentByTarget(targetId) {
    $(".js-content").removeClass("is-current").hide();
    $("#" + targetId).addClass("is-current").show();
  }
  showContentByTarget($initial.data("target"));

  /************* タブ切り替え *************/
  $tabs.on("click", function () {
    $tabs.removeClass("is-current");
    var $t = $(this).addClass("is-current");
    var targetId = $t.data("target");
    showContentByTarget(targetId);
    ensureModelSelect($("#" + targetId));           // セレクト未生成なら作る
    loadAllListsForContent($("#" + targetId));      // 5リストを読み込み
  });

  $(".tab-buttons__next").on("click", function () {
    var $cur = $tabs.filter(".is-current");
    var $next = $cur.nextAll(".js-tab").first();
    if ($next.length) $next.trigger("click");
  });
  $(".tab-buttons__prev").on("click", function () {
    var $cur = $tabs.filter(".is-current");
    var $prev = $cur.prevAll(".js-tab").first();
    if ($prev.length) $prev.trigger("click");
  });

  /************* 5つのリストをまとめてロード *************/
  async function loadAllListsForContent($content, selectedTag) {
    const $lists = $content.find(".lp-item__list[data-collection-url]");
    if (!$lists.length) return;

    for (let i = 0; i < $lists.length; i++) {
      await loadOneList($($lists[i]), $content, selectedTag);
    }
  }

  async function loadOneList($list, $content, selectedTag) {
    const baseUrl = $list.attr("data-collection-url");
    const handle  = $list.attr("data-collection-handle");
    if (!baseUrl || !handle) return;

    // 機種タグ選択時のURL切替（任意のシリーズは /collections/all-case/<tag> へ）
    const allCaseHandles = ["series-iphone","series-android","xperia-series","galaxy-series","pixel-series","xiaomi-series","motorola-series"];
    let url = baseUrl;
    if (selectedTag) {
      url = allCaseHandles.includes(handle)
        ? `${localeRoot}/collections/all-case/${selectedTag}`
        : `${localeRoot}/collections/${handle}/${selectedTag}`;
    }

    $list.html('<div class="collection-loading">読み込み中...</div>');

    try {
      const res = await fetch(url, { credentials: "same-origin" });
      if (!res.ok) throw new Error("Fetch failed: " + url);

      const text = await res.text();
      const doc  = new DOMParser().parseFromString(text, "text/html");

      // テーマ差異を吸収
      const grid =
        doc.querySelector(".collection.grid") ||
        doc.querySelector("#product-grid") ||
        doc.querySelector('[data-id="product-grid"]') ||
        doc.querySelector(".collection__products");

      let html = "";
      if (grid) {
        const items = Array.from(grid.querySelectorAll(".product-item"));
        const empty = grid.querySelector(".collection-empty");
        if (items.length) html = items.map((el) => el.outerHTML).join("");
        else html = empty ? empty.outerHTML : grid.innerHTML;
      } else {
        html = '<div class="collection-empty">商品が見つかりませんでした。</div>';
      }

      $list.html(html);

      // ▼ 見た目の後処理（仕様変更反映）
      // full：col_ + productname_（既存互換）
      // half：col_ のアンダーバー以降だけ
      // none：現状通り
      const titleMode = ($content.attr("data-show-title") || "full").toLowerCase(); // full | half | none
      const showPrice = String($content.attr("data-show-price")).toLowerCase() === "true";

      $list.find(".product-item").each(function () {
        const $item  = $(this);
        const $title = $item.find(".product-slideShow-title");
        if (!$title.length) return;

        // tags 取得（data-product-tags が JSON 文字列の想定）
        const tagsAttr = $item.attr("data-product-tags");
        let tags = [];
        if (tagsAttr) {
          try {
            const decoded = tagsAttr.replace(/&quot;/g, '"');
            tags = JSON.parse(decoded) || [];
          } catch (e) {
            console.error("titleタグ解析失敗:", e);
          }
        }

        // none：タイトル触らない（= display:block を当てない前提）
        if (titleMode === "none") return;

        // col_ / productname_ 抽出
        const colTag     = tags.find(t => t.startsWith("col_"));
        const productTag = tags.find(t => t.startsWith("productname_"));

        const colText     = colTag ? stripPrefix(colTag, "col_") : "";
        const productTitle = $item.data("product-item-title") || "";
        const productText = window.caseplayDisplayTitle(productTitle, productTag);

        // half：省略表示 → col_ のアンダーバー以降だけ（= col_ 除去後）
        if (titleMode === "half") {
          if (colText) {
            $title.text(normalizeTitleForDisplay(colText));
            return;
          }
          // col_ が無い場合フォールバック（最初のハイフン以降）
          const t = $title.text();
          const m = t.match(/.*?-([\s\S]*)/);
          const base = m && m[1] ? m[1].trim() : t.trim();
          $title.text(normalizeTitleForDisplay(base));
          return;
        }

        // full：全表示 → col_ + productname_（既存互換）
        let base;
        if (colText || productText) {
          base = mergeRemoveOverlap(colText, productText, " ");
        } else {
          // タグが無い場合は旧仕様フォールバック（最初のハイフン以降）
          const t = $title.text();
          const m = t.match(/.*?-([\s\S]*)/);
          base = m && m[1] ? m[1].trim() : t.trim();
        }

        $title.text(normalizeTitleForDisplay(base));
      });

      // 表示制御
      if (titleMode !== "none") {
        $list.find(".product-slideShow-title").css({ display: "block", textAlign: "center" });
      }
      if (showPrice) {
        $list.find(".product-slideShow-price").css({ display: "block" });
      }

      // freeword タグ表示
      $list.find(".product-item").each(function () {
        const $item = $(this);
        const tagsAttr = $item.attr("data-product-tags");
        if (!tagsAttr) return;
        try {
          const decoded = tagsAttr.replace(/&quot;/g, '"');
          const tags = JSON.parse(decoded);
          const fw = tags.filter((t) => t.startsWith("freeword_"));
          if (fw.length) {
            const $w = $('<div class="product-slideShow-freeword-list"></div>');
            fw.forEach((t) => $w.append(
              $('<span class="product-slideShow-freeword-tag"></span>').text(t.replace("freeword_", ""))
            ));
            $item.append($w);
          }
        } catch (e) { console.error("freeword解析失敗:", e); }
      });

    } catch (e) {
      console.error(e);
      $list.html('<div class="collection-empty">読み込みでエラーが発生しました。</div>');
    }
  }

  /************* 機種セレクト：タブ毎に生成、全リストへ反映 *************/
  function ensureModelSelect($content) {
    const $box = $content.find(".manufacturer_selector");
    if (!$box.length) return;
    if ($box.find(".model-select").length) return; // 既にある

    const $sel = $('<select class="model-select"></select>').append(
      $('<option value="" disabled selected></option>').text(modelSelectPrompt)
    );
    $box.append($sel);

    var currentTag  = "{{current_tags}}";
    var modelGroups = window.fox?.settings?.model_groups_checkbox || [];

    function addOpt(code, label) {
      $sel.append(`<option value="mo_${code}">${label}</option>`);
      if (currentTag.match(`mo_${code}`)) $sel.addClass("add_check");
    }

    modelGroups.forEach((g) => {
      (g.code_sort || []).forEach((code) => {
        if (/AP/.test(code)) addOpt(code, `${window.fox.settings.model[code]} (iPhone)`);
        else addOpt(code, `${window.fox.settings.model[code]} (Android)`);
      });
    });

    $sel.on("change", function () {
      const tag = $(this).val();
      loadAllListsForContent($content, tag); // 現タブ内の5リストを全て再取得
    });
  }

  // 初回：最初のタブのセレクト生成＆5リスト読込
  ensureModelSelect($("#" + $initial.data("target")));
  loadAllListsForContent($("#" + $initial.data("target")));
});
